import React, {Component} from "react";
import "./CalendarPage.css";
import CardActionComp from "../../components/calendar/card/CardActionComp";
import {Header, Loading, PageContainer} from "../../genericComponents";

class CalendarPage extends Component {
  constructor(props) {
    super(props);

    const date = new Date()
    this.state = {
      loadingCounter: 1,
      deliveryDateRange: [date, new Date().setDate(date.getDate() + 2)],
    };
  }

  addLoading = () => {
    this.setState((state) => ({loadingCounter: (state.loadingCounter += 1)}));
    console.log(this.state.loadingCounter)
  };

  render() {
    let { loadingCounter, deliveryDateRange} = this.state;
    const key = JSON.stringify(deliveryDateRange || '-|-')
    return (
      <Loading loading={loadingCounter !== 0} hideChildrenWhileLoading>
        {/*Header Page*/}
        <Header active="Agenda" logged/>
        {/*<div className="row" style={{padding: "10px"}}>*/}
        {/*  <div className="col-3">*/}
        {/*    <label>Filtrar data de entrega</label>*/}
        {/*    <DateRangePicker*/}
        {/*      format={"dd/MM/yyyy"}*/}
        {/*      value={deliveryDateRange}*/}
        {/*      onChange={date => this.setState({deliveryDateRange: date})}*/}
        {/*    />*/}
        {/*  </div>*/}
        {/*</div>*/}
        <PageContainer row>
          <CardActionComp
            key={`action-${key}`}
            addLoading={this.addLoading}
            subtractLoading={this.subtractLoading}
            deliveryDate={deliveryDateRange}
          />
        </PageContainer>
      </Loading>
    );
  }

  subtractLoading = () => {
    this.setState((state) => ({loadingCounter: (state.loadingCounter = state.loadingCounter === 0 ? 0 : state.loadingCounter - 1)}));
    console.log(this.state.loadingCounter)
  };
}

export default CalendarPage;
